export type ClientUserType = 'anonymous' | 'authenticated';

// Client-side-only context (no IP — that is server-only, see requestContext.ts). Read by the
// browser branch of logger.ts and fed by ClientLogContextSyncComponent at app bootstrap.
export interface ClientLogContext {
  readonly route: string | null;
  readonly sessionGuid: string | null;
  readonly userType: ClientUserType;
  readonly buildId: string | null;
}

// userType has a safe synchronous default: until proven otherwise, a client is anonymous, not
// "unknown" — unlike route/sessionGuid/buildId, which have no meaningful value before they are
// resolved and stay null until ClientLogContextSyncComponent's effect flushes.
const initialClientLogContext: ClientLogContext = {
  route: null,
  sessionGuid: null,
  userType: 'anonymous',
  buildId: null
};

let currentClientLogContext: ClientLogContext = initialClientLogContext;

export const getClientLogContext = (): ClientLogContext => currentClientLogContext;

export const updateClientLogContext = (patch: Partial<ClientLogContext>): void => {
  currentClientLogContext = { ...currentClientLogContext, ...patch };
};
